import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  resetEnterprise,
  requestEnterprise,
  resetState as resetGlobalState,
} from "./store/slices/globalSlice";
import { usePrevious } from "./components/common/hooks";
import { resetLoading } from "./store/slices/loadingBarSlice";
import * as GlobalHelper from "./helpers/GlobalHelper";

const DomainHandler = ({
  global,
  loader,
  requestEnterprise,
  resetLoading,
  resetGlobalState,
  setIsAppReady,
  isAppReady = false,
}) => {
  const intl = useIntl();

  const prevDomainRequestLoading = usePrevious({
    requesting: global.requesting,
  });

  const domain = window.location.hostname.split(".")[0];

  const isAdminDomain = (domain) => {
    return GlobalHelper.CheckIfRootDomain(domain);
  };

  useEffect(() => {
    if (!isAppReady) {
      if (isAdminDomain(domain)) {
        resetGlobalState(null);
        setIsAppReady(true);
        loader > 0 && resetLoading();
      } else {
        requestEnterprise({ domain });
      }
    }
  }, [requestEnterprise, setIsAppReady, isAppReady, resetGlobalState]);

  useEffect(() => {
    if (
      global.enterprise &&
      prevDomainRequestLoading &&
      !global.requesting &&
      !global.error
    ) {
      setIsAppReady(true);
      loader > 0 && resetLoading();
    }
  }, [
    global.requesting,
    global.error,
    global.enterprise,
    setIsAppReady,
    prevDomainRequestLoading,
  ]);

  const isAdmin = isAdminDomain(domain);

  return (
    <div className="edexlms-spinner">
      {(!isAdmin && global.requesting && (
        <>
          <ProgressSpinner />
          <h2>
            {intl.formatMessage({
              id: "loading_environment",
              defaultMessage: "Loading Environment. Please wait...",
            })}
          </h2>
        </>
      )) ||
        null}
      {(!isAdmin && !global.requesting && global.error && (
        <>
          <i
            className="pi pi-ban"
            style={{ fontSize: "3rem", color: "var(--red-600)" }}
          ></i>
          <h2>
            {intl.formatMessage({
              id: "error_loading_environment",
              defaultMessage:
                "Error Loading Environment. Please try again later.",
            })}
          </h2>
        </>
      )) ||
        null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  global: state.global,
  loader: state.loadingBar.loader,
});

const mapDispatchToProps = (dispatch) => ({
  resetEnterprise: () => dispatch(resetEnterprise),
  requestEnterprise: (data) => dispatch(requestEnterprise(data)),
  resetGlobalState: (data) => dispatch(resetGlobalState(data)),
  resetLoading: () => dispatch(resetLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DomainHandler);
